import fullView from '../../../assets/images/character-illustration-1.jpg'

export default function DefaultModal() {
    return(
        <>
            <img src={fullView} alt='' />
        </>
    );
}